<template>
  <div class="dialog-list" :style="{height: scrollerHeight + 'px'}">
    <div class="dialog-container clearfix" v-for="message in messages">
      <answers v-if="message.source == 'needService'" :type="1"></answers>
      <answers v-if="message.source == 'needLeave'" :type="2"></answers>

      <div class="message-template clearfix" v-if="message.status == '0'">
        <div class="prompt-message">
          message.message
        </div>
      </div>

      <div class="message-template clearfix" v-if="message.source == 'ocs'">
        <div class="person-icon"></div>
        <div class="message-container">
          <div class="triangle"></div>
          <div class="message"> {{ message.message }}</div>
        </div>
      </div>

      <div class="message-template clearfix" v-if="message.source == 'img'">
        <div class="person-icon"></div>
        <div class="message-container">
          <div class="triangle"></div>
          <div class="message">
            <img :src="message.img">
          </div>
        </div>
      </div>

      <div class="message-template clearfix" v-if="message.source == 'info'">
        <div class="info">{{ message.message }}</div>
      </div>

      <div class="message-template clearfix" v-if="message.source == 'queue'">
        <div class="queue">
          <span>您前面还有 <span class="queue-number">{{ message.number }}</span>  人咨询排队（3分钟内不会退出排队），逛逛其他页面回来可继续咨询。</span>
        </div>
      </div>

      <div class="message-template clearfix" v-if="message.source == 'join'">
        <div class="join">
          申通客服: <span class="join-name" >{{ message.name }} </span> 为您服务！愉快聊起来~
          <br>
          请放心！我们不会以任何理由向您索取个人信息，如帐号、密码、身份证等
        </div>
      </div>

      <div class="message-template clearfix" v-if="message.source == 'plugin'">
        <div class="person-icon"></div>
        <div class="message-container">
          <div class="triangle"></div>
          <div class="message">请填写您的个人联系信息</div>
        </div>
      </div>
      <div class="message-template clearfix" v-if="message.source == 'plugin'">
        <user-info-card :content="message.content"></user-info-card>
      </div>

      <div class="message-template clearfix" v-if="message.source == 'user'">
        <div class="user-message-template">
          <div class="user-icon"></div>
          <div class="user-message-container">
            <div class="antiTriangle"></div>
            <div class="user-message"> {{ message.message }}</div>
          </div>
        </div>
      </div>

      <div class="message-template clearfix" v-if="message.source == 'userInfo'">
        <div class="person-icon"></div>
        <div class="message-container">
          <div class="triangle"></div>
          <div class="message"> {{ message.message }}</div>
        </div>
      </div>

      <div class="message-template clearfix" v-if="message.source == 'userImg'">
        <div class="user-message-template">
          <div class="user-icon"></div>
          <div class="user-message-container">
            <div class="antiTriangle"></div>
            <div class="user-message">
              <img :src="message.message">
            </div>
          </div>
        </div>
      </div>

      <template v-if="message.source == 'robot'">
        <div v-if="message.type == 0">
          <multi-issues :content="message.content"></multi-issues>
        </div>
        <div v-if="message.type == 2 || message.type == 5 || message.type == 8">
          <div class="message-template clearfix">
            <div class="person-icon"></div>
            <div class="message-container">
              <div class="triangle"></div>
              <div class="message"> {{ message.content[0].text?message.content[0].text:'小二不太明白你说的话' }}</div>
            </div>
          </div>
          <answers v-if="message.transfer" :type="1"></answers>
        </div>
        <div v-if="message.type == 3">
          <many-issues :content="message.content"></many-issues>
          <answers v-if="message.transfer" :type="1"></answers>
        </div>
        <div v-if="message.type == 4">
          <answers :type="3"></answers>
        </div>
        <div v-if="message.type == 6">
          <multi-answers :content="message.content"></multi-answers>
          <answers v-if="message.transfer" :type="1"></answers>
        </div>
        <div v-if="message.type == 7">
          <div class="message-template clearfix">
            <div class="person-icon"></div>
            <div class="message-container">
              <div class="triangle"></div>
              <div class="message" >亲，马上帮您转接专业的人工客服进行解答哦，请稍等～</div>
            </div>
          </div>
        </div>
      </template>

      <feedback-card v-if="message.source =='evaluation'" :message=message.data :service=message.serviceId></feedback-card>

    </div>
  </div>
</template>

<script>
  import MultiIssues from './dialog/MultiIssues'
  import MultiAnswers from './dialog/MultiAnswers'
  import ManyIssues from './dialog/ManyIssues'
  import Answers from './dialog/Answers'
  import VisitorCheck from './dialog/VisitorCheck'
  import UserInfoCard from './dialog/UserInfoCard'
  import FeedbackCard from './dialog/FeedbackCard'

  export default {
    props: ['scrollerHeight', 'messages'],
    data() {
      return {
        needFeedback: false,
        feel: ''
      }
    },
    events: {

    },
    methods: {
      deQueue: function () {
        this.$dispatch('de-queue');
      }
    },
    watch: {

    },
    components:{
      MultiIssues,
      MultiAnswers,
      ManyIssues,
      Answers,
      VisitorCheck,
      UserInfoCard,
      FeedbackCard
    }
  }
</script>

<style scoped rel="stylesheet/less" lang="less">
  @import "../assets/base.less";
  .dialog-list {
    overflow: auto;
    position: relative;
  }
  .info {
    padding-left: 66px;
    color: @tintGray;
    font-size: 12px;
  }

  .queue {
    padding-left: 66px;
    color: @tintGray;
    font-size: 12px;
    .queue-number {
      color: @red;
    }
  }

  .join {
    padding-left: 66px;
    font-size: 12px;
    color: @tintGray;
    .join-name {
      color: @black;
    }
  }
</style>



// WEBPACK FOOTER //
// DialogContainer.vue?1840a19d